import React from 'react';
import PublicLayout from './PublicLayout';

export default function AboutPage() {
  return (
    <PublicLayout title="About ScensobConnect" eyebrow="Company">
      <p className="lead">ScensobConnect is an enterprise staffing marketplace built to connect healthcare and human-services operators with vetted workers in minutes — not days.</p>
      <h2>Our mission</h2>
      <p>Every group home, hospital, and agency in North America should be able to fill a shift, verify a credential, and pay a worker without a back-office of spreadsheets and phone calls. We're building the platform that makes that the default.</p>
      <h2>What we do</h2>
      <ul>
        <li><strong>For workers:</strong> a single profile that proves you're qualified, lets you accept shifts with one tap, and pays you on time.</li>
        <li><strong>For employers:</strong> verified talent, automatic compliance tracking, real-time attendance, and audit-grade reporting.</li>
        <li><strong>For agents/agencies:</strong> roster management, sub-agent hierarchy, bulk operations, and a single P&amp;L view across all clients.</li>
        <li><strong>For program managers:</strong> location-level dashboards, training rollout, and incident workflows that satisfy state oversight requirements.</li>
      </ul>
      <h2>Built for the regulated edge</h2>
      <p>Healthcare staffing isn't ride-sharing. Lives depend on the right person being in the right room at the right time. Every feature we ship is designed against the constraints HIPAA, USPS, ASAP, and the IRS impose on us — not bolted on after the fact.</p>
      <h2>Get in touch</h2>
      <p>Interested in piloting ScensobConnect at your organization? <a href="/contact">Contact our team</a> or <a href="/enterprise">explore Enterprise plans</a>.</p>
    </PublicLayout>
  );
}
